package com.neurobs.react.semanticui

import com.neurobs.js.util.RandomString
import com.neurobs.react.{ReactUtil, StyleUtil}
import com.neurobs.util.Guid
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement
import slinky.web.html._


object UiCheckboxFactory {

  private def templateSingleCheckbox(display: String, handleChange: () => Unit, isChecked: Boolean)(uiElementModifiers: UiElementModifiers) = {

    div(
      className := uiElementModifiers.formattedClassName("checkbox"),
      style := uiElementModifiers.createStyle
    )(
      input(
        `type` := "checkbox",
        onChange := handleChange,
        checked := isChecked
      ),
      label(className := "white-text")(display)
    )
  }

  private def templateOptionCheckbox[T](inputType: String = "radio", inline: Boolean = false)(selections: List[T], labelGenerator: T => String, selectionHandler: T => Unit, isSelected: T => Boolean, classString: String = "") = {

    div(
      className := s"ui form $classString"
    )(
      div(className := (if (inline) "inline fields" else "grouped fields"))(
        selections.map(selection => {
          val labelString = labelGenerator(selection)
          div(className := "field", key := labelString)(
            div(className := "ui checkbox")(
              input(
                `type` := inputType,
                name := labelString,
                onClick := {() => selectionHandler(selection)},
                checked := isSelected(selection),
                onChange := {() => {}}
              ),
              label(className := "white-text")(labelString)
            )
          )
        })
      )
    )
  }

  def SingleOptionCheckbox(display: String, handleChange: () => Unit, isChecked: Boolean)(implicit uiElementModifiers: UiElementModifiers) = {
    templateSingleCheckbox(display, handleChange, isChecked)(uiElementModifiers)
  }

  def verticalRadioCheckbox[T](selections: List[T], labelGenerator: T => String, selectionHandler: T => Unit, isSelected: T => Boolean, classString: String = "") = {
    templateOptionCheckbox()(selections, labelGenerator, selectionHandler, isSelected, classString)
  }

  def horizontalRadioCheckbox[T](title: String, selections: List[T], labelGenerator: T => String, selectionHandler: T => Unit, isSelected: T => Boolean, classString: String = ""): ReactElement = {
    val inputName = RandomString.generate(length = 16)
    span(
      b(title), b(": "),
      selections map { selection =>
         val label = labelGenerator(selection)
         span(key := label)(
           input(
             `type` := "radio",
				  className := "efactory-radio",
             name := inputName,
             onClick := {() => selectionHandler(selection)},
             checked := isSelected(selection),
             onChange := {() => {}}
           ),
           s" $label "
         )
      }
    )
  }
}

